import React from 'react'

import Icon from 'components/Icon'
import Block from 'components/icons/attacks/Block'
import Chip from 'components/icons/attacks/Chip'
import Cores from 'components/icons/attacks/Cores'
import Corrupt from 'components/icons/attacks/Corruption'
import Delay from 'components/icons/attacks/Delay'
import Desync from 'components/icons/attacks/Desync'
import Device from 'components/icons/attacks/Device'
import Directory from 'components/icons/attacks/Directory'
import DiskVolume from 'components/icons/attacks/DiskVolume' // Disk volume for disk percentage
import Exact from 'components/icons/attacks/Exact'
import FullMatch from 'components/icons/attacks/FullMatch'
import Hostname from 'components/icons/attacks/Hostname'
import Interval from 'components/icons/attacks/Interval'
import Ip from 'components/icons/attacks/Ip'
import KillChildren from 'components/icons/attacks/KillChildren'
import Loss from 'components/icons/attacks/Loss'
import Modes from 'components/icons/attacks/Modes'
import Newest from 'components/icons/attacks/Newest'
import OffsetTime from 'components/icons/attacks/OffsetTime'
import Oldest from 'components/icons/attacks/Oldest'
import Port from 'components/icons/attacks/Port'
import Protocol from 'components/icons/attacks/Protocol'
import Reboot from 'components/icons/attacks/Reboot'
import Regex from 'components/icons/attacks/Regex'
// import Traffic from './Traffic' // Traffic has not meta match at the moment - needs input from josh
import theme from 'theme'
import { SnakeCaseAttackArgs } from 'types/api/attacks/details/targeting'

const UserIcon = (props) => <Icon icon="user" {...props} />
const UsersIcon = (props) => <Icon icon="users" {...props} />

type ArgIconsType = {
  [key in keyof Required<
    Omit<
      SnakeCaseAttackArgs,
      'type' | 'cli_args' | 'providers' | 'traffic_impact_mapping' | 'length'
    > & {
      fallback: string
    }
  >]: React.ComponentType
}

const ARG_ICONS: ArgIconsType = {
  all_cores: Cores,
  block_count: Hostname,
  block_size: Block,
  cores: Cores,
  corrupt: Corrupt,
  delay: Delay,
  device: Device,
  directory: Directory,
  egress_ports: Port,
  exact: Exact,
  fallback: Loss, // Generic fallback icon in the case of error
  full_match: FullMatch,
  gigabytes: Chip,
  group: UsersIcon,
  hostnames: Hostname,
  ingress_ports: Port,
  interval: Interval,
  ip_addresses: Ip,
  protocol: Protocol,
  kill_children: KillChildren,
  megabytes: Chip,
  mode: Modes,
  milliseconds: OffsetTime,
  newest: Newest,
  disable_n_t_p: Desync,
  offset: OffsetTime,
  oldest: Oldest,
  percent: Loss, // need to add disk volume for disk percent
  process: Regex,
  reboot: Reboot,
  source_ports: Port,
  user: UserIcon,
  workers: Cores
}

type AttackArgIconProps = {
  className?: string
  attack?: string
  icon?: string
}

const AttackArgIcon = React.forwardRef<React.Ref<any>, AttackArgIconProps>(
  ({ className, attack, icon = 'fallback', ...rest }, ref) => {
    const objectKey = icon.replace('--', '')
    let IconComponent

    if (attack === 'disk' && objectKey === 'percent') {
      IconComponent = DiskVolume
    } else if (ARG_ICONS[objectKey]) {
      IconComponent = ARG_ICONS[objectKey]
    } else {
      IconComponent = ARG_ICONS['fallback']
    }

    return (
      <IconComponent
        ref={ref}
        className={className}
        css={{ fontSize: theme.fontSizes[2] }}
        {...rest}
      />
    )
  }
)

AttackArgIcon.displayName = 'AttackArgIcon'

export default AttackArgIcon
